import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TellentAnalytics } from '@core/tellent-util';

@Injectable({ providedIn: 'root' })
export class CurrentUserAnalyticsService extends TellentAnalytics {
  public readonly namespace = 'CurrentUserProfile';
  public readonly requireViewContext = false;

  public route = inject(ActivatedRoute);

  public trackDialogOpen(viewContext?: string): void {
    const params = this.route.snapshot.queryParams;
    this.track('DialogOpen', { opened_from: viewContext || params.viewContext });
  }

  public trackGrandAccess(action: 'grant_access' | 'revoke_access') {
    this.track('TeamAccess', { action });
  }

  public trackPasswordChanged() {
    this.track('ChangePassword');
  }
}
